import EventBus from '@/eventbus.js'
require('@/security.js')

export const qrSocketInputMixin = {
  methods: {
    buildQRWebSocket () {
      this.closeQRWebSocket()

      var browserUUID = this.$uuid.v4()
      this.$store.state.socket.browserUuid = browserUUID
      var url = this.$store.state.socket.qrUrl + '?browserUUID=' + browserUUID

      let vm = this
      const qrConnection = new WebSocket(url)
      this.$store.state.socket.qrConnection = qrConnection
      qrConnection.onmessage = data => {
        if (vm.$store.state.socket.qrConnection === qrConnection) {
          vm.socketMessageReceived(data)
        }
      }
    },

    closeQRWebSocket () {
      const qrConnection = this.$store.state.socket.qrConnection
      if (qrConnection === null) {
        return
      }

      qrConnection.onmessage = null
      if (qrConnection.readyState === WebSocket.CONNECTING || qrConnection.readyState === WebSocket.OPEN) {
        qrConnection.close()
      }
      if (this.$store.state.socket.qrConnection === qrConnection) {
        this.$store.state.socket.qrConnection = null
      }
    },

    socketMessageReceived (event) {
      EventBus.$emit('log', {
        type: 'info',
        text: 'Socket mesaj alındı'
      })
      this.processWebSocketInput(event.data)
    },

    processWebSocketInput (inputString) {
      var input = JSON.parse(inputString)
      switch (input.Task) {
        case 'set_qr':
          this.processSetQrCode(input)
          break
        case 'auth_browser':
          this.processAuthBrowser(input)
          break
        default:
          break
      }
    },

    processSetQrCode (input) {
      EventBus.$emit('SetQrCode', input.QRUUID)
    },

    processAuthBrowser (input) {
      this.$store.state.session.user.Token = input.Token
      this.$store.state.session.user.UserID = input.UserID
      this.slo('ssn', this.$store.state.session)
      this.$router.push({
        name: 'Home'
      })
    }
  }
}
